// import 'antd/dist/antd.min.css'
import React, { useCallback, useState, useLayoutEffect, useMemo } from "react";
import { Row, Col } from "react-bootstrap"
import Search from "./header/Search"
import Header from "../Header";

import styles from "./style.module.css"
import { Tag } from "rsuite"
import { format,startOfMonth, endOfMonth } from "date-fns"
import axiosService from "../../utils/axios.service";
import _ from "lodash"
import async from "async"
import { Line } from '@ant-design/plots';
import { Table, Spin } from "antd"
import getDates from "../constant/getDates"
import { DataGrid } from '@mui/x-data-grid';
import "./scss/report.scss"
import StorageService from "../../utils/storage.service";

const ReportCustomerBusiness = () => {
    const columns = [
        {
            title: 'Mã đơn hàng',
            dataIndex: 'order_code',
            render: (data) => {
                return (
                    <p className="text3">{data}</p>
                )
            },
        },
        {
            title: 'Ngày thanh toán',
            dataIndex: 'transaction_at',
            width: 150,
            render: (data) => {
                return (
                    <p className="text4">{data}</p>
                )
            },
        },
        {
            title: 'Tên khách hàng',
            dataIndex: 'customer_name',
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'customer_mobile',
            with: 150,
            render: (data) => {
                return (
                    <p className="text_service_none">{data}</p>
                )
            },
        },
        {
            title: 'Thẻ lựa chọn',
            dataIndex: 'product_name_up',
            render: (data) => {
                return (
                    <p className="text_service_none">{data}</p>
                )
            
            },
        },
        {
            title: 'Thẻ nâng cấp',
            dataIndex: 'product_name',
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            
            },
        },
        {
            title: 'Doanh số thuần',
            dataIndex: 'total_amount',
            render: (data) => {
                return (
                    <p className="text7">{convertCurrency(data)}</p>
                )
            },
        },
        {
            title: 'Tiền đã thu',
            dataIndex: 'paid',
            render: (data) => {
                return (
                    <p className="text7">{convertCurrency(data)}</p>
                )
            },
        },
        {
            title: 'Tiền thực thu bán hàng',
            dataIndex: 'paidNoTax',
            render: (data) => {
                return (
                    <p className="text7">{convertCurrency(data)}</p>
                )
            },
        },
        {
            title: 'Loại thanh toán',
            dataIndex: 'status',
            render: (data) => {
                return (
                    <p className="text4">{data}</p>
                )
            },
        },
    ];
    const title = "Dịch vụ nâng cấp"
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(0)
    const [isExport, setIsExport] = useState(false)
    const [loading, setLoading] = useState(true);
    const [table, setTable] = useState([])
    const [keyword, setKeyword] = useState([])
    const [total, setTotal] = useState(0)
    const [count, setCount] = useState(0)
    const [row, setRow] = useState(15)
    const [totalPaid, setTotalPaid] = useState(0) 
    const [totalPaidNoTax, setTotalPaidNoTax] = useState(0) 
    const [data8Vung, setData8Vung] = useState({})
    const [dataPre, setDataPre] = useState({})
    const [userId, setUserId] = useState(0)
    const [emulationId, setEmulationId] = useState(0)
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [emulationOption, setEmulationOption] = useState([])

    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }
    const handleStore = (x) => {
        setStore(x)
    }

    const handleUser = (x) => {
        setStore(x.value)
    }

    const handleEmulation = (x) => {
        setEmulationId(x.value)
    }

    const fetchData = async (sD, eD, s) => {
        const { emulation, data } = await async.parallel({
            emulation: (cb) => {
                axiosService(`api/emulation/`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            },
            data: (cb) => {
                axiosService(`api/mysql/report-upgrade-new-product/all?start=${sD}&end=${eD}&store=${store}&user_id=${userId}&product_id=${emulationId}`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            }
        })
        if (data.code === 200) {
            setLoading(false)
            const {totalAmount, totalPaid, totalPaidNoTax, totalOrder, dataTable, dataOption, data8Vung, dataPre} = data.data

            setTable(dataTable)
            setTotal(totalAmount)
            setCount(totalOrder)
            setTotalPaid(totalPaid)
            setTotalPaidNoTax(totalPaidNoTax)
            setData8Vung({...data8Vung})
            setDataPre({...dataPre})
            setEmulationOption([...dataOption])
        }
    }
    useLayoutEffect(() => {
        setLoading(true)
        fetchData(startDate, endDate, store)
    }, [startDate, endDate, store,keyword, userId, emulationId])

    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
    const handleExportData = () => {
        setLoading(true)
        var url = `api/mysql/export/report-upgrade-new-product/all?start=${startDate}&end=${endDate}&store=${store}&user_id=${userId}&product_id=${emulationId}`
        axiosService(url, "GET")
        .then((res) => {
            if (res.data.code == 200) {
                window.location.href = res.data.data.url
                setLoading(false)
            }
        }).catch((error) => {
            console.log(error)
            setLoading(false)
        });
    }
    const onChangeKeyword = (e) => {
        setKeyword(e)
    }
    const  handleChange = (e) => {
        setRow(e.pageSize)
    }

    return (
        <>
        <div className={`container-fluid ${styles.background}`}>
            <Search startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} store={store}
                handleStore={handleStore}
                handleUser={handleUser}
                handleEmulation={handleEmulation}
                title={title} type={"hopper"}
                csvData={table} isExport={isExport}
                handleExportData={handleExportData}
                onChangeKeyword={onChangeKeyword}
                emulation = {emulationOption}
                header={
                    [
                        { label: 'Nhân viên', key: "user_name" },
                        { label: "Số lịch đã xác nhận", key: "countBooking" },
                        { label: "Hoa hồng xác nhận lịch", key: "rose_confirm" },
                        { label: "Số khách đón tiếp", key: `countCustomer` },
                        { label: "Hoa hồng đón tiếp", key: `rose_welcome` },
                    ]
                }
                userAdmin={userAdmin}
            />
            <Spin spinning={loading} tip="Đang tải...">
                <Row>
                    <Col md={8} xs={12}>
                        <Row className="h-100">
                            <Col md={4} xs={12}>
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <span className={styles.textTag3}>Thống kê: </span>
                                    <div className="d-flex justify-content-between p-1">
                                        <div>
                                            <span className={styles.textTag4}>Doanh số thuần: </span>
                                            <span className={styles.textTag4}>Tiền đã thu: </span>
                                            <span className={styles.textTag4}>Thực thu bán hàng: </span>
                                            <span className={styles.textTag4}> Số thẻ: </span>
                                            
                                        </div>
                                        <div className="ml-3">
                                            <span className={styles.textTag2}> {convertCurrency(total)}</span>
                                            <span className={styles.textTag2}> {convertCurrency(totalPaid)}</span>
                                             <span className={styles.textTag2}> {convertCurrency(totalPaidNoTax)}</span>
                                            <span className={styles.textTag2}> {count}</span>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col md={4} xs={12}>
                                <Tag color="green" className="w-100 p-2 h-100">
                                <span className={styles.textTag3}>Triệt lông Premium - 10 buổi: </span>
                                    <div className="d-flex justify-content-between p-1">
                                        <div>
                                            <span className={styles.textTag4}>Doanh số thuần: </span>
                                            <span className={styles.textTag4}>Tiền đã thu: </span>
                                            <span className={styles.textTag4}>Thực thu bán hàng: </span>
                                            <span className={styles.textTag4}> Số thẻ: </span>
                                        </div>
                                        <div className="ml-3">
                                            <span className={styles.textTag2}>{convertCurrency(dataPre.totalAmount || 0)}</span>
                                            <span className={styles.textTag2}>{convertCurrency(dataPre.totalPaid || 0)}</span>
                                            <span className={styles.textTag2}>{convertCurrency(dataPre.totalPaidNoTax || 0)}</span>
                                            <span className={styles.textTag2}>{dataPre.count}</span>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col md={4} xs={12}>
                                <Tag color="violet" className="w-100 p-2 h-100">
                                <span className={styles.textTag3}>Triệt - 8 vùng - 10 buổi: </span>
                                    <div className="d-flex justify-content-between p-1">
                                        <div>
                                            <span className={styles.textTag4}>Doanh số thuần: </span>
                                            <span className={styles.textTag4}>Tiền đã thu: </span>
                                            <span className={styles.textTag4}>Thực thu bán hàng: </span>
                                            <span className={styles.textTag4}> Số thẻ: </span>
                                        </div>
                                        <div className="ml-3">
                                            <span className={styles.textTag2}>{convertCurrency(data8Vung.totalAmount || 0)}</span>
                                            <span className={styles.textTag2}>{convertCurrency(data8Vung.totalPaid || 0)}</span>
                                            <span className={styles.textTag2}>{convertCurrency(data8Vung.totalPaidNoTax || 0)}</span>
                                            <span className={styles.textTag2}>{data8Vung.count || 0}</span>
                                            
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mt-2" style={{alignItems: 'end'}}>
                    <Col xs={12} md={12}>
                        <div style={{ backgroundColor: "white" }} >
                            <div className="border-bottom mb-1 p-2">
                                <strong className="m-2">Bảng dữ liệu chi tiết</strong>
                            </div>
                            <div style={{ height: 495, width: '100%' }} className="p-2">
                                <Table 
                                    columns={columns} 
                                    dataSource={[...table]}
                                    pagination={{ pageSize: row, showSizeChanger: true, pageSizeOptions: ['5', '15', '30', '50', '100'] }}
                                    scroll={{ x: 900 }}
                                    onChange={handleChange}
                                    bordered
                                    rowKey="transaction_code"
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div>
        </>
    )
}
export default ReportCustomerBusiness